import { useMutation, useQueryClient } from '@tanstack/react-query';

import { VesselProduct } from '../../../../types/VesselProduct';
import { updateVesselProduct } from '../../../common/api/clients/vessel.api';
import { queries } from '../../../common/api/queryKeys/queries';

interface UpdateVesselProductParams {
    vesselProductId: string;
    vesselProduct: VesselProduct;
}

export const useUpdateVesselProduct = (vesselId: string) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ vesselProductId, vesselProduct }: UpdateVesselProductParams) =>
            updateVesselProduct({ vesselId, vesselProductId, vesselProduct }),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: queries.vessels.detail(vesselId)._ctx.products.queryKey,
            });
        },
    });
};
